import {
  type PropsWithChildren,
  useCallback,
  useRef,
  useState,
  useLayoutEffect,
} from 'react';
import type { Word } from './WordCloud';

export const WordCloudResizer = ({
  children,
  height,
  width,
  words,
}: PropsWithChildren<{
  height: number;
  width: number;
  words: Word[];
}>) => {
  const wordCloudRef = useRef<SVGSVGElement>(null);
  const [scale, setScale] = useState<number>(0.1);

  const calculateScale = useCallback(() => {
    if (wordCloudRef.current && width > 0 && height > 0) {
      const bbox = wordCloudRef.current.getBBox();
      if (bbox.width > 0 && bbox.height > 0) {
        setScale(
          Math.round(Math.min(height / bbox.height, width / bbox.width) * 10) /
            10,
        );
      }
    }
  }, [height, width]);

  useLayoutEffect(() => {
    if (words.length > 0) {
      calculateScale();
    }
  }, [words, calculateScale]);

  return (
    <g transform={`translate(${width / 2},${height / 2})`}>
      <g
        ref={wordCloudRef}
        style={{
          transform: `scale(${scale ?? 1})`,
          transition: 'transform 0.3s ease-in-out',
        }}
      >
        {children}
      </g>
    </g>
  );
};
